module.exports = __webpack_public_path__ + "30b08221071ab3df93f4492c406a4862.svg";